import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { LetterComment } from '@coin/shared/core/util-models';
import { environment } from '@coin/shared/core/util-environments';
import { HttpHelpersService } from './http-helpers';

@Injectable({
  providedIn: 'root'
})
export class MeritBudgetCommentService {
  private httpClient = inject(HttpClient);
  private dialog = inject(MatDialog);
  private httpHelper = inject(HttpHelpersService);

  getComments(seasonId: string, employeeId: string) {
    return this.httpClient
      .get<
        LetterComment[]
      >(`${environment.api.baseUrl}/admin/api/v2/master/seasons/merit/${seasonId}/allocations/values/${employeeId}/comments`)
      .pipe(this.httpHelper.handleError('Error getting comments'));
  }

  // employeeId is really employeeId and not allocation member id
  postComment(seasonId: string, employeeId: string, message: string, reason?: string) {
    return this.httpClient
      .post(
        `${environment.api.baseUrl}/admin/api/v2/master/seasons/merit/${seasonId}/allocations/values/${employeeId}/comments`,
        {
          value: message,
          reason
        }
      )
      .pipe(this.httpHelper.handleError('Error posting comment'));
  }
}
